// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/societa/:id',
    requestBody: null,
    response: '{"societa":{"id":"number","nome":"string","amministratori":"array","soci":"array"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/societa/:id',
    requestBody: '{"nome":"string","dominio":"string","ragioneSociale":"string?","partitaIva":"string?","capitaleSociale":"number?"}',
    response: '{"societa":{...}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/societa/:id/amministratori/:ammId',
    requestBody: null,
    response: '{"ok":true}'
  },
  {
    method: 'GET',
    endpoint: '/api/societa/:id/amministratori/:ammId/documento',
    requestBody: null,
    response: 'binary'
  },
  {
    method: 'PUT',
    endpoint: '/api/societa/:id/amministratori/:ammId',
    requestBody: '{"nome":"string"}',
    response: '{"amministratore":"object"}'
  },
  {
    method: 'POST',
    endpoint: '/api/societa/:id/amministratori',
    requestBody: '{"nome":"string","cognome":"string"}',
    response: '{"amministratore":"object"}'
  },
  {
    method: 'POST',
    endpoint: '/api/societa/:id/amministratori/:ammId/documento',
    requestBody: 'multipart',
    response: '{"amministratore":"object"}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/societa/:id/amministratori/:ammId/documento',
    requestBody: null,
    response: '{"amministratore":"object"}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/societa/:id/soci/:socioId',
    requestBody: null,
    response: '{"ok":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/societa/:id/soci/:socioId',
    requestBody: null,
    response: '{"socio":"object"}'
  },
  {
    method: 'POST',
    endpoint: '/api/societa/:id/soci',
    requestBody: null,
    response: '{"socio":"object"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
